// extracted by mini-css-extract-plugin
export default {"footer_Button":"footer_Button_tIiev8L4","arrow_upward":"arrow_upward_USBhIoPr","footer__list":"footer__list_HHlFqyfA"};